import {
  CarInfoTable,
  CarInfoHeader,
  CarInfoCell,
} from "@app/components/InfoTable";
import { isOddEven, formatPercentFactor, formatNumber } from "@app/utils";
import { Fragment } from "react";
import { BoundaryItem } from "./useSimulationModelsBoundaries";

export const SimulationModelsBoundariesBoundaryTable = (props: {
  items: BoundaryItem[];
}) => {
  return (
    <CarInfoTable sx={{ gridTemplateColumns: "0.5fr 1fr 1fr 1fr 1fr 1fr 1fr" }}>
      <CarInfoHeader text="" />
      <CarInfoHeader text="Boundary Type" />
      <CarInfoHeader text="Expected Return" />
      <CarInfoHeader text="Residual Lower Boundary" />
      <CarInfoHeader text="Lower Boundary Rate" />
      <CarInfoHeader text="Residual Upper Boundary" />
      <CarInfoHeader text="Upper Boundary Rate" />
      {props.items.map((row, rowIdx) => (
        <Fragment key={rowIdx}>
          <CarInfoCell
            isOdd={isOddEven(rowIdx)}
            justifyContent="start"
            text={`Year ${row.year}`}
          />
          <CarInfoCell isOdd={isOddEven(rowIdx)} text={row.boundaryType} />
          <CarInfoCell
            isOdd={isOddEven(rowIdx)}
            text={
              row.expectedReturn
                ? formatPercentFactor(row.expectedReturn, {
                    decimalPlaces: 4,
                  })
                : "-"
            }
          />
          <CarInfoCell
            isOdd={isOddEven(rowIdx)}
            text={
              row.residualLowerBoundary
                ? formatNumber(row.residualLowerBoundary, { decimalPlaces: 6 })
                : "-"
            }
          />
          <CarInfoCell
            isOdd={isOddEven(rowIdx)}
            text={
              row.lowerBoundaryRate
                ? formatNumber(row.lowerBoundaryRate, { decimalPlaces: 6 })
                : "-"
            }
          />
          <CarInfoCell
            isOdd={isOddEven(rowIdx)}
            text={
              row.residualUpperBoundary
                ? formatNumber(row.residualUpperBoundary, { decimalPlaces: 6 })
                : "-"
            }
          />
          <CarInfoCell
            isOdd={isOddEven(rowIdx)}
            text={
              row.upperBoundaryRate
                ? formatNumber(row.upperBoundaryRate, { decimalPlaces: 6 })
                : "-"
            }
          />
        </Fragment>
      ))}
    </CarInfoTable>
  );
};
